import { debounce } from 'underscore';
import classname from 'classnames';
import React, { Component} from 'react';
import PropTypes from 'prop-types';
import BZPopover from 'web-common/bizzabo-components/components/BZPopover';
import LoginPopover from './LoginPopover';
import RegisterAndLoginPopper from './RegisterAndLoginPopper';
import ExternalUrlRedirectModal from './VirtualSessions/ExternalUrlRedirectModal';
import FeatureToggleUtils from 'FeatureToggleUtils';


import { VirtualSessionIcon } from '@bizzabo/icons';
import NoAccessToVirtualSessionPopover from './NoAccessToVirtualSessionPopover';
import {getSession} from '../ApiUtil';

class WatchExternalOnDemandSessionButton extends Component {
    state = {
        isRedirectModalVisible: false,
        externalSolutionUrl: '',
    };

    static propTypes = {
        event: PropTypes.object.isRequired,
        siteConf: PropTypes.shape({}),
        me: PropTypes.object.isRequired,
        session: PropTypes.object.isRequired,
        eventUrls: PropTypes.object.isRequired,
        showEmailLogin: PropTypes.func,
        showRegisterAndLoginModal: PropTypes.func.isRequired,
        ticketsSelectionData: PropTypes.object.isRequired,
    };

    sendVirtualSessionPostMessage = (virtualSessionDetailsObject) => {
        const {ticketsSelectionData = {}, me = {}, session} = this.props;
        const { primaryEmail } = me;
        const { tickets = [] } = ticketsSelectionData;
        const ticketIds = tickets.map( ticket => ticket.id);
        const postMessageData = {
            sessionId: session?.id,
            attendeeCastingUrl: virtualSessionDetailsObject?.link,
            attendeeEmail: primaryEmail,
            attendeeTickets: ticketIds,
            messageType: 'watchOnDemand'
        };
        window.parent.postMessage(postMessageData, '*');
    }

    onClickWatchOnDemandButton = async() => {
        const { session, event } = this.props;
        const {externalSessionAssets = [], recordingSession ={}} = session;
        const {externalAssetId} = recordingSession;
        const getExternalSessionAsset = (assets = [], assetId) => {
            const currentExternalAsset = assets.find(asset => asset.id === assetId);
            return currentExternalAsset;
        };
        const externalSolutionDetails = getExternalSessionAsset(externalSessionAssets, externalAssetId);
        let externalSolutionDetailsObject;
        if (externalSolutionDetails){
            externalSolutionDetailsObject = externalSolutionDetails.config;
        } else {
            const fullSessionObject = await getSession({ eventId: event?.id, sessionId: session?.id });
            const externalAsset = getExternalSessionAsset(fullSessionObject?.externalSessionAssets, externalAssetId);
            externalSolutionDetailsObject = externalAsset?.config;
        }
        const isVirtualSessionEnabled = FeatureToggleUtils.isFeatureEnabled('feature-virtual-enable-virtual-suite');
        if (isVirtualSessionEnabled && externalSolutionDetailsObject?.joinAction === 'POST_MESSAGE') {
            this.sendVirtualSessionPostMessage(externalSolutionDetailsObject);
        } else {
            this.showRedirectModal(externalSolutionDetailsObject?.link);
        }
    };

    showRedirectModal = url => {
        this.setState({ isRedirectModalVisible: true, externalSolutionUrl: url });
    };

    hideRedirectModal = () => {
        this.setState({ isRedirectModalVisible: false });
    };

    redirectToExternalLink = () => {
        window.open(this.state.externalSolutionUrl);
        this.hideRedirectModal();
    }

    getBroadcastBtnOverlay = ({
        btnText,
        clsBroadcastButton,
        clickCallback,
        isButtonDisabled,
        showIcon = true,
    }) => (
        <button
            className={clsBroadcastButton}
            onClick={(event) => {
                !isButtonDisabled && clickCallback && clickCallback();
                const { setLoginV2OffsetTop, siteConf: { isWidget } } = this.props;
                if (isWidget && window.self !== window.parent) {
                    setLoginV2OffsetTop?.(event.pageY);
                }
            }}
        >
            {showIcon && (
                <VirtualSessionIcon
                    className="broadcast-icon"
                    fill="#ffffff"
                    fontSize="20px"
                />
            )}
            <span>{btnText}</span>
        </button>
    );

    render() {
        const {
            showEmailLogin,
            eventUrls,
            me,
            btnText = 'Watch On demand',
            showIcon = true,
            isDisabled,
            showRegisterAndLoginModal,
            siteConf,
            btnClass,
            analyticData
        } = this.props;

        const isAuthenticated = me && me.id;
        const { isBroadcastLoading, sessionAccessError, isRedirectModalVisible } = this.state;
        const isButtonHasDisabledView = isBroadcastLoading || isDisabled;
        const isButtonDisabled = isButtonHasDisabledView || !isAuthenticated;
        const isWidget = siteConf?.isWidget;
        const clsBroadcastButton = classname(`join-broadcast-btn bz-button font-size-12 custom-color color-1-background color-1-hover-opacity ${btnClass}`, {'broadcast-disabled': isButtonHasDisabledView });

        const clickCallback = debounce(this.onClickWatchOnDemandButton, 1000, true);
        const isAgendaLoginFlowEnabled = !FeatureToggleUtils.isFeatureEnabled('oldLogin');

        return (
            <>
                {
                    !isAuthenticated &&
                        (isAgendaLoginFlowEnabled ? (
                            (isWidget && window.self !== window.parent) ? (
                                <RegisterAndLoginPopper
                                    button={this.getBroadcastBtnOverlay({
                                        btnText,
                                        clsBroadcastButton,
                                        isButtonDisabled: false,
                                        showIcon
                                    })}
                                    onLoginClick={showEmailLogin}
                                    eventUrls={eventUrls}
                                    eventName={event.name}
                                    analyticData={analyticData}
                                />
                            ) : (
                                this.getBroadcastBtnOverlay({
                                    btnText,
                                    clsBroadcastButton,
                                    clickCallback: showRegisterAndLoginModal,
                                    isButtonDisabled: false,
                                    showIcon
                                })
                            )
                        ) : (
                            <BZPopover
                                placement="right"
                                cls="need-login-popover"
                                button={this.getBroadcastBtnOverlay({
                                    btnText,
                                    clsBroadcastButton,
                                    clickCallback,
                                    isButtonDisabled,
                                    showIcon
                                })}
                                popover={
                                    <LoginPopover
                                        onLoginClick={showEmailLogin}
                                        eventUrls={eventUrls}
                                        analyticData={analyticData}
                                    />
                                }
                            />
                        ))
                }
                {
                    isAuthenticated && !sessionAccessError &&
                    this.getBroadcastBtnOverlay({
                        btnText,
                        clsBroadcastButton,
                        clickCallback,
                        isButtonDisabled,
                        showIcon
                    })
                }
                {
                    sessionAccessError &&
                    <BZPopover
                        placement='right'
                        cls="no-access-to-session-popover"
                        defaultOverlayShown
                        onHide={() => this.setState({ sessionAccessError: null })}
                        button={this.getBroadcastBtnOverlay({
                            btnText,
                            clsBroadcastButton,
                            clickCallback,
                            isButtonDisabled,
                            showIcon
                        })}
                        popover={<NoAccessToVirtualSessionPopover sessionAccessError={sessionAccessError}/>}
                    />
                }
                <ExternalUrlRedirectModal
                    show={isRedirectModalVisible}
                    onHide={this.hideRedirectModal}
                    onContinue={this.redirectToExternalLink}
                    isLive={false}
                />
            </>
        );
    }
}

export default WatchExternalOnDemandSessionButton;
